import React from 'react';
import AddToCalendar from 'react-add-to-calendar';
import { useLanguage } from 'src/hooks/Language';
import { ContainerAddToSchedule } from './styles';

const AddToSchedule = ({ data }) => {
    const { language } = useLanguage();
    const event = {
        title: data.title,
        description: data.description,
        location: data.local,
        startTime: data.startAt,
        endTime: data.endAt,
    };
    let icon = { 'calendar-plus-o': 'right' };
    return (
        <ContainerAddToSchedule
            background={data?.background}
            color={data?.color}
            fontSize={data?.fontSize}
            padding={data?.padding}
            borderRadius={data?.borderRadius}

        >
            <AddToCalendar buttonLabel={language === 'en' ? 'Add to calendar' : language === 'es' ? 'Añadir a tu calendario' : 'Adicionar na agenda'} buttonTemplate={icon} event={event} />
        </ContainerAddToSchedule>
    );
};

export default AddToSchedule;